module.exports = __webpack_public_path__ + "static/media/related-pro-img1.8cd20ee6.jpg";